export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14634.812c6fa7.jpg";